var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRename = function SvgRename(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.417 0 2.75 2.75L5.5 17.417l-2.75-2.75-.917.916 2.75 2.75L0 20.167l1.833-4.584.917-.916zM22 22v-1.833H4.583L0 22z"
  })));
};
export { SvgRename as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjQxNjcgMEwyMC4xNjY3IDIuNzVMNS41IDE3LjQxNjdMMi43NSAxNC42NjY3TDEuODMzMzMgMTUuNTgzM0w0LjU4MzMzIDE4LjMzMzNMMCAyMC4xNjY3TDEuODMzMzMgMTUuNTgzM0wyLjc1IDE0LjY2NjdMMTcuNDE2NyAwWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIyIDIyVjIwLjE2NjdINC41ODMzM0wwIDIySDIyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";